import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('Organisationseinheit')

export default {
  label: 'Organisationseinheit',
  route: 'organisationseinheit',
  className: 'organisationseinheit',
  fields: [
    ListFields.UnsortableReference('ueberOrganisationseinheit', false),
    ListFields.SortableField('name', true),
    ListFields.SortableDate('beginn', false),
    ListFields.SortableDate('ende', false),
    ListFields.SortableField('kostenstelle', true),
    ListFields.UnsortableReference('orgaIdent', false),
    ListFields.UnsortableReference('unterOrganisationseinheiten', false),
    ListFields.SortableBoolean('inPubfob', true),
    ListFields.SortableBoolean('obsolet', true)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Organisationseinheit.js